import React from 'react';
import { MapPin, Heart, Sparkles } from 'lucide-react';
import { TESTIMONIALS, IMAGES } from '../mock';

const Testimonials = () => (
  <section className="section" id="stories" data-testid="testimonials-section">
    <div className="container">
      <div className="section-title">
        <div className="eyebrow">Example matches</div>
        <h2>Good matches start with good questions.</h2>
        <p>Illustrative examples of the kind of compatible matches Krysha identifies from your answers. Profile images are AI-generated for privacy.</p>
      </div>
      <div className="tgrid">
        {TESTIMONIALS.map((t, i) => (
          <div className="tcard" key={t.names}>
            <div className="tphoto" role="img" aria-label={`Example match profile — ${t.names}, ${t.city} (AI-generated image)`} style={{ backgroundImage: `url('${IMAGES.testimonials[i]}')` }}>
              <span className="ex-badge" data-testid={`example-badge-${i}`}>Example Match</span>
              <span className="tmatch"><Heart size={11} fill="#fff" /> {t.match}</span>
            </div>
            <div className="tbody">
              <b>{t.names}</b>
              <span className="tcity"><MapPin size={12} /> {t.city}</span>
              <div className="ttags">
                {t.tags.map((tag) => <span className="ttag" key={tag}>{tag}</span>)}
              </div>
              <p>{t.text}</p>
              <span className="ai-note"><Sparkles size={10} /> AI-generated image shown for privacy.</span>
            </div>
          </div>
        ))}
      </div>
      <p className="example-disclaimer" data-testid="example-matches-disclaimer">
        These profiles are illustrative examples, not real registered members. Match details are shown to demonstrate how Krysha's compatibility matching works.
      </p>
    </div>
  </section>
);

export default Testimonials;
